module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lead-update-business-kits lead-mask gutter-xs row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-5 col-lg-5"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('ui.business_kit.send')))]), _vm._v(" "), _c('tag-list', {
    attrs: {
      "label": "Tags",
      "name": "tags",
      "value": _vm.item.tags
    },
    on: {
      "input": _vm.tagUpdate
    }
  }), _vm._v(" "), (_vm.items.length > 0) ? _c('div', [_c('field', {
    staticClass: "businesskit-select",
    attrs: {
      "model": "business_kit",
      "name": "select",
      "params": {
        no_i18n: true
      },
      "type": "select",
      "collection": _vm.items,
      "value": _vm.business_kit_id
    },
    on: {
      "input": _vm.emitBusinessKitId
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-bk"
  }, [_c('a', {
    staticClass: "link is-margin-bottom-20",
    attrs: {
      "href": this.selected_businesskit_url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('ui.business_kit.preview')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "field field-checkbox"
  }, [_c('div', {
    staticClass: "field--wrapper"
  }, [_c('div', {
    staticClass: "field--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.authorization),
      expression: "authorization"
    }],
    staticClass: "input--checkbox",
    attrs: {
      "type": "checkbox",
      "id": "authorization",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.authorization) ? _vm._i(_vm.authorization, "true") > -1 : (_vm.authorization)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.authorization,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.authorization = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.authorization = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.authorization = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "authorization"
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.business_kit.confirmation')))])])])])], 1) : _c('div', [_vm._v("\n        " + _vm._s(_vm.$t('ui.pages.lead-no-businesskit')) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    class: {
      'is-disabled': !_vm.business_kit_id || !_vm.authorization || _vm.loading, '': _vm.loading
    },
    attrs: {
      "disabled": !_vm.authorization
    },
    on: {
      "click": _vm.send_businesskit
    }
  }, [_vm._v(_vm._s(_vm.$t('ui.business_kit.send_confirm')))])]), _vm._v(" "), (this.redirect_url) ? _c('div', {
    staticClass: "message"
  }, [_c('p', {
    class: _vm.messageType
  }, [_vm._v("\n          " + _vm._s(_vm.messageContent) + "\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "link is-margin-bottom-20",
    attrs: {
      "href": this.redirect_url,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(this.$t('models.business_kit.create_template')))])]) : _c('div', {
    staticClass: "message"
  }, [_c('p', {
    class: _vm.messageType
  }, [_vm._v("\n          " + _vm._s(_vm.messageContent) + "\n        ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bk-activity col-xs-12 col-sm-12 col-md-5 col-lg-5 offset-md-1"
  }, [(!_vm.businesskit_history.length) ? _c('div', {
    staticClass: "empty-state-bk-history"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/empty-default.svg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('ui.business_kit.activity')))])]) : _vm._e(), _vm._v(" "), (_vm.businesskit_history.length) ? _c('h3', [_vm._v("\n        " + _vm._s(_vm.$t('ui.business_kit.history')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.businesskit_history.length) ? _c('div', {}, _vm._l((_vm.businesskit_history), function(bk) {
    return _c('div', {
      key: bk.eventbaxx_event_name,
      staticClass: "truncate-text"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": bk.bag_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(bk.eventbaxx_event_name))]), _vm._v(" "), _c('p', {
      staticClass: "bk-history--date"
    }, [_vm._v("\n              " + _vm._s(_vm.$t('models.business_kit.status.' + bk.status)) + " on " + _vm._s(_vm.moment(bk.transferred_at).format("DD.MM.YYYY - HH:mm")) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "bk-history--mobile"
    }, [_c('p', [_vm._v("\n              " + _vm._s(_vm.moment(bk.transferred_at).format("DD.MM.YYYY HH:mm"))), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": bk.bag_url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(bk.eventbaxx_event_name) + " - " + _vm._s(_vm.$t('models.business_kit.status.' + bk.status)))])])])])
  }), 0) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ed7dbb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/leads/LeadUpdateBusinessKit.vue
// module id = 1903
// module chunks = 0